import Leave from "../../../../components/company/organization/leave"

const LeavePage = () => {
    return <Leave />
}

export default LeavePage;